module.exports = __webpack_public_path__ + "static/img/Brian-Too.a51655b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brian-Too.jpg
// module id = o8V8
// module chunks = 0